export default {
      id: "arrow-back-usage",
      viewBox: "0 0 14 14",
      url: "/" + "img/marilyn-ui.svg#arrow-back",
      toString: function () {
        return this.url;
      }
    }